Game.Utils.PlayerAnimation = {

	run: function( man ) {

		if ( ! man.alive ) {
			return;
		}

		// Run an animation method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {

			var old_animation = man.animation;

			this[ 'run_' + man.state ]( man );

			// Only play the animation if there's a method for the current
			// player state.
			//
			// If there's no method then it's likely there's another animation
			// playing. For example the man may have died.

			// If the animation changes then play the animation - else let it do it's own thing.
			if ( old_animation !== man.animation ) {
				man.animations.play( man.animation );
			}

		}

	},


	/**
	 * Do physics for idle.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_1: function( man ) {

		man.animation = 'idle';

		var man_speed = Math.abs( man.body.velocity.x );

		if ( man_speed > 5 ) {
			man.animation = 'walk';
		}

		if ( man_speed > 30 ) {
			man.animation = 'run';
		}

	},


	/**
	 * Flying animations.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_2: function( man ) {

		man.animation = 'fly';

	},


	/**
	 * Jump animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_3: function( man ) {

		man.animation = 'jump';

		if ( man.body.velocity.y > 2 ) {
			man.animation = 'fall';
		}

	},


	/**
	 * Crawl animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_4: function( man ) {

		man.animation = 'idle-crawl';

		if ( man.body.velocity.x > 2 || man.body.velocity.x < -2 ) {
			man.animation = 'crawl';
		}

	},

	/**
	 * Climb animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_5: function( man ) {

		man.animation = 'idle-climb';

		if ( man.controls.down ) {
			man.animation = 'climb';
		}

		if ( man.controls.up ) {
			man.animation = 'climb';
		}

	},


	run_6: function( man ) {

		man.animation = 'climb-platform';

	},


	run_7: function( man ) {

		man.animation = 'superhero-landing';

	},


	run_8: function( man ) {

		man.animation = 'wall-slide';

	},

	run_9: function( man ) {

		man.animation = 'floor-slide';

	},

	run_10: function( man ) {

		man.animation = 'dive';

	},

};
